module.exports = __webpack_public_path__ + "img/home_bg2.09802c71.jpg";